import type { Property } from '@core/models/properties';
import { selectRegionTreeReferenceDate } from '@state/season/season.selectors';
import { useBoundStore } from '@state/store';
import { useEffect } from 'react';

export function useLoadRegions(property?: Property) {
  const seasonsStatus = useBoundStore((state) => state.seasons.status);
  const referenceDate = useBoundStore(selectRegionTreeReferenceDate);

  useEffect(() => {
    if (!property || seasonsStatus !== 'success') return;
    const { regions, seasons } = useBoundStore.getState();
    if (seasons.status !== 'success') return;
    const fieldSeasons = Object.values(seasons.entities);
    if (regions.status === 'success' && regions.propertyId === property.id) {
      void regions.refresh(property, fieldSeasons);
    } else {
      regions.fetch(property, fieldSeasons);
    }
  }, [property, seasonsStatus, referenceDate]);
}
